// Mega menu alternative collection image: pick a Shopify collection, upload an image
// or select an existing Shopify Files entry, then save its URL to collection.metafields.mega_menu.image.
import React, { useState, useRef, useEffect } from 'react'
import { ajaxPerso, meta } from '../../../fnc'
import Select from 'react-select';

const refConst = require("../../../constants.js").v

const styleList = {
	container: (provided) => ({
		...provided,
		width: "100%",
	}),
	menu: (provided) => ({
		...provided,
		zIndex: 99999
	}),
}

export default function AddMegaMenuCollectionImage(props){

	const [collections, setCollections] = useState([]);
	const [selectedCollection, setSelectedCollection] = useState(null);
	const [currentImageUrl, setCurrentImageUrl] = useState(null);
	const [imageMode, setImageMode] = useState("upload");
	const [fileSearch, setFileSearch] = useState("");
	const [searchResults, setSearchResults] = useState({ imgs: [], info: null });
	const [selectedFile, setSelectedFile] = useState(null);
	const [searchLoading, setSearchLoading] = useState(false);
	const [reloadReact, setReloadReact] = useState(0);
	const refInputImg = useRef(null);

	useEffect(() => {
		if(!props.shop)	return
		loadCollections()
	}, [props.shop])

	useEffect(() => {
		if(!props.shop || !selectedCollection) {
			setCurrentImageUrl(null);
			return;
		}

		meta.fetch({
			shop: props.shop.id,
			namespace: "mega_menu",
			key: "image",
			urlPrefix: `collections/${selectedCollection.id}/`
		}, (r) => {
			if(r.success && r.res && r.res.length > 0){
				setCurrentImageUrl(r.res[0].value || null);
			}else{
				setCurrentImageUrl(null);
			}
		});
	}, [props.shop, selectedCollection])

	const loadCollections = () => {
		props.loading(true);
		ajaxPerso({
			"api": "shopify",
			"trigger": "downloadCollection",
			"shop": props.shop.id,
		}, (r) => {
			props.loading(false);
			if(!r.success){
				props.info({ error: r.error || "Unable to load collections" });
				return;
			}

			const sorted = (r.data || [])
				.map(o => ({
					id: String(o.id || o.legacyResourceId || ""),
					handle: o.handle || "",
					title: o.title || o.handle || "",
					defaultImage: o.image?.url || null,
				}))
				.filter(o => o.id && o.handle)
				.sort((a, b) => a.title.localeCompare(b.title));

			setCollections(sorted);
		});
	}

	const fetchAdminFiles = (args, callback) => {
		ajaxPerso(Object.assign({
			"api": "shopify",
			"trigger": "get_admin_files",
			"shop": props.shop.id,
			"autoLoad": false,
			"qty": 20,
			"includeDetails": false,
		}, args), callback);
	}

	const searchExistingFiles = (afterCursor = null) => {
		const filterName = fileSearch.trim();
		if(!filterName){
			props.info({ error: "Enter a filename search term." });
			return;
		}

		setSearchLoading(true);
		if(!afterCursor) props.loading(true);

		const reqData = {
			"filter_name": filterName,
		};
		if(afterCursor) reqData.after = afterCursor;

		fetchAdminFiles(reqData, (r) => {
			setSearchLoading(false);
			if(!afterCursor) props.loading(false);

			if(r.errors){
				props.info({ error: r.errors });
				return;
			}
			if(!r.success){
				props.info({ error: "Unable to search Shopify files." });
				return;
			}

			if(afterCursor){
				setSearchResults(prev => ({
					imgs: prev.imgs.concat(r.urlList || []),
					info: r.pageInfo || null,
				}));
			}else{
				setSearchResults({
					imgs: r.urlList || [],
					info: r.pageInfo || null,
				});
				setSelectedFile(null);
			}
		});
	}

	const loadMoreSearchResults = () => {
		if(searchResults.info?.endCursor){
			searchExistingFiles(searchResults.info.endCursor);
		}
	}

	const saveMegaMenuImage = (imageUrl) => {
		props.loading(true);

		ajaxPerso({
			"api": "shopify",
			"trigger": "set_collection_mega_menu_image",
			"uid": props.getUser().uid,
			"shop": props.shop.id,
			"collectionId": selectedCollection.id,
			"collectionHandle": selectedCollection.handle,
			"imageUrl": imageUrl,
			"token": refConst.tokenEio,
		}, (r) => {
			props.loading(false);

			if(r.errors){
				props.info({ error: r.errors });
			}else if(r.success){
				const savedUrl = r.data?.imageUrl || imageUrl;
				setCurrentImageUrl(savedUrl);
				props.info({ success: "Mega menu image saved on collection metafield." });
			}else{
				props.info({ error: "Save failed." });
			}
		});
	}

	const submitImgChange = (e) => {
		e.preventDefault();

		let errors = [];
		if(!selectedCollection)
			errors.push("Please select a collection");

		if(imageMode === "upload"){
			if(!refInputImg.current || refInputImg.current.files.length !== 1)
				errors.push("Please select one image only");
		}else if(!selectedFile){
			errors.push("Please select an existing Shopify file");
		}

		if(errors.length > 0){
			props.info({ error: errors });
			return;
		}

		if(imageMode === "existing"){
			saveMegaMenuImage(selectedFile.url);
			return;
		}

		props.loading(true);

		const formData = new FormData();
		formData.append("img", refInputImg.current.files[0], refInputImg.current.files[0].name);
		formData.append("api", "shopify");
		formData.append("trigger", "set_collection_mega_menu_image");
		formData.append("uid", props.getUser().uid);
		formData.append("shop", props.shop.id);
		formData.append("collectionId", selectedCollection.id);
		formData.append("collectionHandle", selectedCollection.handle);
		formData.append("token", refConst.tokenEio);

		ajaxPerso(formData, (r) => {
			props.loading(false);

			if(r.errors){
				props.info({ error: r.errors });
			}else if(r.success){
				const imageUrl = r.data?.imageUrl || null;
				setCurrentImageUrl(imageUrl);
				props.info({ success: "Mega menu image saved on collection metafield." });
				if(refInputImg.current) refInputImg.current.value = "";
				setReloadReact(reloadReact + 1);
			}else{
				props.info({ error: "Upload failed." });
			}
		}, null, {
			contentType: false,
			processData: false,
			cache: false,
			async: true,
		});
	}

	const collectionOptions = collections.map(o => ({
		value: o.id,
		label: o.title,
		collection: o,
	}));

	return (
		<div className={"border radius m-3 p-3 w-100 bg-light " + ("className" in props ? props.className : "")}>
			<form onSubmit={submitImgChange}>
				<div className="pb-2 font-weight-bold">Mega menu collection image</div>
				<div className="text-muted small mb-4">
					Upload a new image or pick one already in Shopify Files. The URL is saved on
					{" "}<code>collection.metafields.mega_menu.image</code> for the theme mega menu.
				</div>

				<div className="mb-4">
					<label className="small font-weight-bold text-uppercase text-muted mb-2 d-block">Collection</label>
					<Select
						styles={styleList}
						placeholder="Select a collection"
						onChange={(selectedOption) => {
							setSelectedCollection(selectedOption ? selectedOption.collection : null);
						}}
						options={collectionOptions}
						value={selectedCollection ? [{
							value: selectedCollection.id,
							label: selectedCollection.title,
						}] : null}
						isSearchable={true}
					/>
				</div>

				{selectedCollection ? (
					<div className="mb-4 p-3 bg-white border rounded">
						<label className="small font-weight-bold text-uppercase text-muted mb-3 d-block">Current images</label>
						<div className="d-flex flex-wrap">
							{currentImageUrl ? (
								<div className="p-2 mr-4">
									<div className="small font-weight-bold mb-2">Mega menu image</div>
									<div
										style={{
											backgroundImage: `url('${currentImageUrl}')`,
											backgroundSize: "contain",
											backgroundPosition: "center center",
											backgroundRepeat: "no-repeat",
											height: "140px",
											width: "200px",
											border: "1px solid #dee2e6",
											borderRadius: "4px",
											backgroundColor: "#fff",
										}}
									/>
								</div>
							) : (
								<div className="p-2 mr-4 text-muted small align-self-center">No mega menu image set yet.</div>
							)}
							{selectedCollection.defaultImage ? (
								<div className="p-2">
									<div className="small font-weight-bold mb-2 text-muted">Default collection image</div>
									<div
										style={{
											backgroundImage: `url('${selectedCollection.defaultImage}')`,
											backgroundSize: "contain",
											backgroundPosition: "center center",
											backgroundRepeat: "no-repeat",
											height: "140px",
											width: "200px",
											border: "1px solid #dee2e6",
											borderRadius: "4px",
											backgroundColor: "#fff",
											opacity: 0.85,
										}}
									/>
								</div>
							) : ""}
						</div>
					</div>
				) : ""}

				<div className="mb-3">
					<label className="small font-weight-bold text-uppercase text-muted mb-2 d-block">Image source</label>
					<div className="btn-group" role="group">
						<button
							type="button"
							className={"btn btn-sm " + (imageMode === "upload" ? "btn-primary" : "btn-outline-primary")}
							onClick={() => setImageMode("upload")}
						>
							Upload new image
						</button>
						<button
							type="button"
							className={"btn btn-sm " + (imageMode === "existing" ? "btn-primary" : "btn-outline-primary")}
							onClick={() => setImageMode("existing")}
						>
							Use existing file
						</button>
					</div>
				</div>

				<div className="mb-4 p-3 bg-white border rounded">
					{imageMode === "upload" ? (
						<div>
							<label className="small font-weight-bold text-uppercase text-muted mb-2 d-block" htmlFor="megaMenuCollectionImageFile">
								Choose image
							</label>
							<div className="custom-file w-100">
								<input
									ref={refInputImg}
									type="file"
									className="custom-file-input"
									id="megaMenuCollectionImageFile"
									accept="image/*"
									required={imageMode === "upload"}
									onChange={() => setReloadReact(reloadReact + 1)}
								/>
								<label className="custom-file-label" htmlFor="megaMenuCollectionImageFile">
									{refInputImg.current && refInputImg.current.files.length === 1
										? refInputImg.current.files[0].name + " (" + (Math.round(refInputImg.current.files[0].size / 1000)) + "Kb)"
										: "Choose image..."}
								</label>
							</div>
						</div>
					) : (
						<div>
							<label className="small font-weight-bold text-uppercase text-muted mb-2 d-block">
								Search Shopify files
							</label>
							<div className="d-flex flex-row align-items-stretch mb-3">
								<input
									type="text"
									className="form-control"
									placeholder="Filename prefix, e.g. megaMenu_power-tools"
									value={fileSearch}
									onChange={(e) => setFileSearch(e.target.value)}
									onKeyDown={(e) => {
										if(e.key === "Enter"){
											e.preventDefault();
											searchExistingFiles();
										}
									}}
								/>
								<button
									type="button"
									className="btn btn-primary ml-2 text-nowrap"
									disabled={searchLoading || !fileSearch.trim()}
									onClick={() => searchExistingFiles()}
								>
									{searchLoading ? "Searching..." : "Search"}
								</button>
							</div>

							{searchResults.imgs.length > 0 ? (
								<div>
									<div className="small text-muted mb-2">Click an image to select it.</div>
									<div className="d-flex flex-wrap justify-content-start">
										{searchResults.imgs.map(o => {
											const isSelected = selectedFile?.id === o.id;
											const sizeChoice = Math.max(o.height || 0, o.width || 0) > 150 ? "contain" : "auto";
											return (
												<div
													key={o.id}
													className={"p-2 " + (isSelected ? "border border-primary rounded bg-light" : "")}
													style={{ cursor: "pointer" }}
													onClick={() => setSelectedFile(o)}
												>
													<div
														style={{
															backgroundImage: `url('${o.url}')`,
															backgroundSize: sizeChoice,
															backgroundPosition: "center center",
															backgroundRepeat: "no-repeat",
															height: "110px",
															width: "110px",
															border: "1px solid #dee2e6",
															borderRadius: "4px",
															backgroundColor: "#fff",
														}}
													/>
													<div className="mt-1 small font-weight-bold text-truncate" style={{ maxWidth: "110px" }} title={o.fileName}>
														{o.fileName}
													</div>
												</div>
											);
										})}
									</div>
									{searchResults.info?.hasNextPage ? (
										<div className="d-flex justify-content-center pt-2">
											<button type="button" className="btn btn-link btn-sm" disabled={searchLoading} onClick={loadMoreSearchResults}>
												Load more results
											</button>
										</div>
									) : ""}
								</div>
							) : (
								<div className="text-muted small">Search by filename prefix to find an image already stored in Shopify Files.</div>
							)}

							{selectedFile ? (
								<div className="mt-3 pt-3 border-top small">
									<span className="text-success font-weight-bold">Selected:</span> {selectedFile.fileName}
								</div>
							) : ""}
						</div>
					)}
				</div>

				<div className="text-center">
					<input
						type="submit"
						name="Save"
						className="btn btn-success px-4"
						value={imageMode === "existing" ? "Use selected file" : "Upload image"}
						disabled={props.loading() || !selectedCollection}
					/>
				</div>
			</form>
		</div>
	);
}
